/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAgreementMetadata
 */
export interface ServiceAgreementMetadata {
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementMetadata
     */
    serviceAgreementAttributeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementMetadata
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementMetadata
     */
    productAttributeId?: string;
}

/**
 * Check if a given object implements the ServiceAgreementMetadata interface.
 */
export function instanceOfServiceAgreementMetadata(value: object): value is ServiceAgreementMetadata {
    return true;
}

export function ServiceAgreementMetadataFromJSON(json: any): ServiceAgreementMetadata {
    return ServiceAgreementMetadataFromJSONTyped(json, false);
}

export function ServiceAgreementMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceAgreementAttributeId': json['serviceAgreementAttributeId'] == null ? undefined : json['serviceAgreementAttributeId'],
        'value': json['value'] == null ? undefined : json['value'],
        'productAttributeId': json['productAttributeId'] == null ? undefined : json['productAttributeId'],
    };
}

export function ServiceAgreementMetadataToJSON(json: any): ServiceAgreementMetadata {
    return ServiceAgreementMetadataToJSONTyped(json, false);
}

export function ServiceAgreementMetadataToJSONTyped(value?: ServiceAgreementMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceAgreementAttributeId': value['serviceAgreementAttributeId'],
        'value': value['value'],
        'productAttributeId': value['productAttributeId'],
    };
}

